import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrows-v-icon',
  templateUrl: './navigation-arrows-v.component.html'
})
export class NavigationArrowsVComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
